import { render } from "./12ReviewsSection.vue?vue&type=template&id=3eb5e104&scoped=true"
import script from "./12ReviewsSection.vue?vue&type=script&lang=js"
export * from "./12ReviewsSection.vue?vue&type=script&lang=js"

import "./12ReviewsSection.vue?vue&type=style&index=0&id=3eb5e104&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb5e104"]])

export default __exports__